var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import '../icon/Icon.js';
let HeaderComponent = class HeaderComponent extends LitElement {
    constructor() {
        super(...arguments);
        this.title = 'Title';
        this.logo = null;
        this.username = null;
        this.organisation = null;
    }
    render() {
        const galigeoUrl = new URL('../../assets/galigeo.png', import.meta.url).href;
        const networkUrl = this.logo || new URL('../../assets/network.png', import.meta.url).href;
        return html `
      <div class="left">
        <slot class="left-start-slot" name="left-start"></slot>
        <img class="logo" src=${galigeoUrl} alt="${msg('Galigeo', { id: 'header.alt.galigeo', desc: 'Galigeo logo alt text' })}" />
        <img class="logo" src="${networkUrl}" alt="${msg('Network', { id: 'header.alt.network', desc: 'Network logo alt text' })}" />
        <span>${this.title}</span>
      </div>
      <div class="right">
        <slot class="slot-content"></slot>
        <span>${this.username || msg('Unknown', { id: 'header.unknownUser', desc: 'Unknown user' })} - ${msg('organization:', { id: 'header.organization', desc: 'Organization label' })} ${this.organisation || msg('Unknown', { id: 'header.unknownOrg', desc: 'Unknown organization' })}</span>
        <basic-icon class="logo" name="user" size="22" .label=${msg('User', { id: 'header.alt.user', desc: 'User icon alt text' })}></basic-icon>
      </div>
    `;
    }
};
HeaderComponent.styles = css `
    :host {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #fff;
      color: white;
      padding: 8px 16px;
      height: 50px; /* Hauteur totale du header */
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    .left, .right {
      display: flex;
      align-items: center;
      height: 100%; /* Assure que les enfants occupent toute la hauteur */
      color: #1c95ff;
    }

    .left span {
      font-weight: bold;
      font-size: 22px;
    }

    .right span {
      color: #333;
      font-size: 11px;
    }

    .logo {
      width: auto; /* Conserve les proportions des images */
      max-height: 30px; /* Hauteur maximale pour les logos */
      margin-right: 8px;
    }
    .right .logo {
      margin-right: 0;
      margin-left: 8px;
        width: 33px; /* Taille plus petite pour l'icône utilisateur */
    }

    .slot-content {
      margin-right: 12px; /* ajuste comme tu veux */
      display: inline-flex; /* évite les marges ignorées par défaut */
    }

    .left-start-slot {
      display: inline-flex;
      align-items: center;
    }

    .left-start-slot::slotted(*) {
      margin-right: 8px;
    }
  `;
__decorate([
    property({ type: String })
], HeaderComponent.prototype, "title", void 0);
__decorate([
    property({ type: String })
], HeaderComponent.prototype, "logo", void 0);
__decorate([
    property({ type: String })
], HeaderComponent.prototype, "username", void 0);
__decorate([
    property({ type: String })
], HeaderComponent.prototype, "organisation", void 0);
HeaderComponent = __decorate([
    localized(),
    customElement('header-component')
], HeaderComponent);
export { HeaderComponent };
//# sourceMappingURL=HeaderComponent.js.map